import { render, staticRenderFns } from "./RecieverInfoEdit.vue?vue&type=template&id=ffecf002&scoped=true"
import script from "./RecieverInfoEdit.vue?vue&type=script&lang=js"
export * from "./RecieverInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./RecieverInfoEdit.vue?vue&type=style&index=0&id=ffecf002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffecf002",
  null
  
)

export default component.exports